export const USER_BADGES = {
  Whale: "Whale",
  "Rising Star": "Rising Star",
  Risky: "Risky",
  "Risky Whale": "Risky Whale",
};

export const USER_STATUS = {
  "New User": "New User",
  // Inactive: "Inactive",
  "Non Buyer Active": "Non Buyer Active",
  "Non Buyer Churn": "Non Buyer Churn",
  "Early Life Active": "Early Life Active",
  "Mature Active": "Mature Active",
  "Early Life Churn": "Early Life Churn",
  "Mature Churn": "Mature Churn",
};

export const USER_TAGGING = {
  "Credit User": "Credit User",
  "Topup User": "Topup User",
};

// Sentinel audience for missions that apply to every user (mirrors the API's
// MISSION_AUDIENCE_ALL). Kept out of USER_STATUS so "All Users" is an explicit choice.
export const MISSION_AUDIENCE_ALL = "ALL";
